export default __webpack_public_path__ + "static/media/cardImg.fe5ef6d6.png";